import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticlePeopleListBlock.module.scss';
import ArticlePersonBlock from '../ArticlePersonBlock';

/**
 * List of people (cards). Basic / Advanced Judging Panel.
 */
const ArticlePeopleListBlock = (props) => {
  const { peopleList, enableSlider } = props;
  const sliderRef = useRef();

  const [scrollPosition, setScrollPosition] = useState(0);

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const elWidth = 335;
  const maxScrollWidth = sliderRef?.current?.scrollWidth - elWidth * 2;

  useEffect(() => {
    sliderRef.current.scrollTo({
      top: 0,
      left: scrollPosition,
      behavior: 'smooth',
    });

    setShowLeftArrow(scrollPosition !== 0);
    setShowRightArrow(scrollPosition !== maxScrollWidth);
  }, [scrollPosition]);

  const scroll = (order) => {
    if (!sliderRef) return;
    const offset = order === 'next' ? elWidth : elWidth * -1;

    if (scrollPosition + offset >= maxScrollWidth) {
      setScrollPosition(maxScrollWidth);
    } else if (scrollPosition + offset <= 0) {
      setScrollPosition(0);
    } else {
      setScrollPosition(scrollPosition + offset);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        ref={sliderRef}
        className={`${style.peopleListContainer} ${
          enableSlider ? style.slider : ''
        }`}
      >
        {peopleList?.map((person, index) => (
          <ArticlePersonBlock
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            name={person?.peopleListGroup?.peopleListName}
            textBio={person?.peopleListGroup?.peopleListBioText}
            imageData={
              person?.peopleListGroup?.peopleListImage?.imgixImage
                ?.gatsbyImageData
            }
            links={person?.peopleListGroup?.peopleListHyperlinks}
            linksHeading={person?.peopleListGroup?.peopleListSubheadingText}
            occupation={person?.peopleListGroup?.peopleListTitle}
          />
        ))}
        {showLeftArrow && (
          <button
            type="button"
            className={`${style.arrow} ${style.left}`}
            onClick={() => scroll('prev')}
          >
            {' '}
          </button>
        )}
        {showRightArrow && (
          <button
            type="button"
            className={`${style.arrow} ${style.right}`}
            onClick={() => scroll('next')}
          >
            {' '}
          </button>
        )}
      </div>
    </div>
  );
};

ArticlePeopleListBlock.propTypes = {
  /**
   * List of people. See the format in ArticlePersonBlock
   */
  peopleList: PropTypes.array.isRequired,
};

export default ArticlePeopleListBlock;
